import {
  SAVE_MANUAL_BOOKING_DRAFT,
  SAVE_MANUAL_BOOKING_DRAFT_SUCCESS,
  SAVE_MANUAL_BOOKING_DRAFT_ERROR,
  SAVE_MANUAL_BOOKING_DRAFT_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const SaveManualBookingDraft = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_MANUAL_BOOKING_DRAFT:
      return { ...state, loading: true, data: null, error: null };
    case SAVE_MANUAL_BOOKING_DRAFT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case SAVE_MANUAL_BOOKING_DRAFT_ERROR:
      return { ...state, loading: false, error: action.payload };
    case SAVE_MANUAL_BOOKING_DRAFT_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default SaveManualBookingDraft;
